import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({
  showSpinner: false
})

const whiteList = ['/', '/login', '/zlgl', '/zlgl/detail', '/register', '/notice/detail', '/home', '/oldHome', '/notice', '/news', '/news/detail', '/notice/list', '/information/detail', '/information', '/guide', '/guide/guideDetail', '/help', '/help/hxdwDetail', '/about', '/notice/noticePage', '/news/newsPage',
  '/information/informationPage', '/forgetPassword', '/system', '/home/detail', '/chatAI', '/internet', '/ajlr', '/helps','/downloadQd/index'
]
router.beforeEach((to, from, next) => {
  const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
  if (to.path === '/oldHome') {
    console.log('强制重定向 /oldHome → /');
    next('/');
    return;
  }

  NProgress.start()
  if (userInfo && userInfo.userId) {
    /* has token*/
    next()
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      console.log(to, 'to');
      next(`/login?redirect=${to.fullPath}`)
      // next('/')
      // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
